export enum EXPORT_TYPE {
    CSV = 'csv',
    PDF = 'pdf',
    EMAIL = 'email',
}

export const EXPORT_DROPDOWN_ITEMS = [
    {
        name: 'PDF',
        value: 'pdf',
    },
    {
        name: 'CSV',
        value: 'csv',
    },
    {
        name: 'EMAIL',
        value: 'email',
    },
]
